import React, { useEffect, useRef, useState } from 'react'
import {
  CButton,
  CRow,
  CSmartTable,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import ToastComponent from 'src/components/common/TaostComponent.js'
import TeamPlayerService from 'src/service/TeamPlayerService'
import { useNavigate } from 'react-router-dom'
import CIcon from '@coreui/icons-react'
import { cilMinus, cilPlus } from '@coreui/icons'
import SquadPickedTable from '../TeamPlayer/SquadPickedTable.js'
const FixtureSquadTable = (props) => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(500)
  const [users, setUsers] = useState({})
  const [pickedPlayer, setPickedPlayer] = useState(props.pickedPlayer)
  const [details, setDetails] = useState([])
  const tableContainerRef = useRef(null)
  const columns = [
    {
      key: 'show_details',
      label: 'Pick',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
    { label: 'Player Name', filter: false, key: 'full_name' },
    { key: 'team_name', filter: true, sorting: false },
  ]
  const toggleDetails = (index) => {
    setLoading(true)
    const position = details.indexOf(index)
    const playerId = index
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
    TeamPlayerService.addInstantPlayer(playerId, props.fixtureId, props.teamId).then((res) => {
      if (res.status === 200) {
        toast.dismiss()
        ToastComponent(res.message, 'success')
        setPickedPlayer(res.picked_player)
        setLoading(false)
      }
    })
  }

  const navigate = useNavigate()
  const deletePlayer = (index, fixtureId) => {
    setLoading(true)
    TeamPlayerService.deleteTeamPlayer(index, fixtureId).then((res) => {
      if (res.status === 200) {
        // Remove the player from details array
        const position = details.indexOf(index)
        let newDetails = details.slice()
        if (position !== -1) {
          newDetails.splice(position, 1)
        }
        setDetails(newDetails)
        setLoading(false)
        toast.dismiss()
        ToastComponent(res.message, 'success')
      }
    })
  }

  const getUsers = useEffect(() => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    TeamPlayerService.getTeamPlayer(
      offset,
      itemsPerPage,
      activePage,
      params,
      props.fixtureId,
      props.teamId,
    ).then((result) => {
      setUsers(result.data)
      setPickedPlayer(result.picked_player)
      const layerIds = result.picked_player.map((l) => l.player_id)
      setDetails(layerIds)

      setLoading(false)
      setTimeout(() => {
        if (tableContainerRef && tableContainerRef.current) {
          tableContainerRef.current.scrollTop = 0
        }
      }, 50)
    })
  }, [activePage, columnFilter, columnSorter, itemsPerPage, props, props.fixtureId])
  return (
    <CModal
      alignment="center"
      size="xl"
      visible={props.visible}
      onClose={() => props.onClose()}
      backdrop="static"
    >
      <CModalHeader>
        <CModalTitle>
          <strong>{props.teamName}</strong>
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div
          ref={tableContainerRef}
          style={users?.data?.length > 15 ? { maxHeight: '360px', overflowY: 'auto' } : {}}
        >
          <CRow>
            <CAccordion activeItemKey={1} className={`${props.individualPlayerDisplay}`}>
              <CAccordionItem itemKey={1}>
                <CAccordionHeader>
                  {' '}
                  <strong>Add Individual Players</strong>
                </CAccordionHeader>
                <CAccordionBody>
                  <CSmartTable
                    columns={columns}
                    columnFilter={{
                      external: true,
                    }}
                    columnSorter={{
                      external: true,
                    }}
                    scopedColumns={{
                      show_details: (item, number) => {
                        return (
                          <>
                            <td className="py-2">
                              {details.includes(item.id) && (
                                <CButton
                                  color={'danger'}
                                  // variant="outline"
                                  shape="square"
                                  onClick={() => {
                                    deletePlayer(item.id, props.fixtureId)
                                  }}
                                >
                                  <CIcon icon={cilMinus} />
                                </CButton>
                              )}
                              {!details.includes(item.id) && (
                                <CButton
                                  color={'success'}
                                  // variant="outline"
                                  shape="square"
                                  onClick={() => {
                                    toggleDetails(item.id)
                                  }}
                                >
                                  <CIcon icon={cilPlus} />
                                </CButton>
                              )}
                            </td>
                          </>
                        )
                      },
                    }}
                    items={users.data}
                    itemsPerPage={itemsPerPage}
                    itemsPerPageSelect={false}
                    loading={loading}
                    pagination={false}
                    paginationProps={{
                      activePage: activePage,
                      pages: Math.ceil(users?.total / itemsPerPage) || 1,
                    }}
                    tableProps={{
                      hover: true,
                      responsive: true,
                    }}
                    onActivePageChange={(activePage) => setActivePage(activePage)}
                    onColumnFilterChange={(filter) => {
                      setActivePage(1)
                      setColumnFilter(filter)
                    }}
                    onItemsPerPageChange={(itemsPerPage) => {
                      setActivePage(1)
                      setItemsPerPage(itemsPerPage)
                    }}
                    onSorterChange={(sorter) => setColumnSorter(sorter)}
                  />
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          </CRow>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={() => props.onClose()}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default FixtureSquadTable
